let NetworkInfoService = /** @class */ (function () {

    /**
     * Check network status
     * @param $q{angular.IQService}
     * @param DeviceService{DeviceService}
     * @param $timeout{angular.ITimeoutService}
     * @constructor
     */
    function NetworkInfoService($q, DeviceService, $timeout) {
        this.$q = $q;
        this.deviceService = DeviceService;
        this.$timeout = $timeout;

        this.init();
    }

    NetworkInfoService.prototype = {
        _connection: true,  // private
        init() {
            this._connection = navigator.onLine;
            this.watchNetworkStatus();
        },
        get connection() {
            if (this.deviceService.isOnCordova()) {
                return this._connection;
            } else {
                return (typeof navigator.onLine === 'boolean') ? navigator.onLine : true;
            }
        },

        /**
         * Update connection
         * @param connection{boolean}
         */
        updateConnection(connection) {
            console.log('updateConnection:' + connection)
            this._connection = connection;
        },

        watchNetworkStatus() {
            // detect network when resume
            this.deviceService.onResume(() => {
                console.log(JSON.stringify({
                    'navigator.onLine': navigator.onLine,
                    'this.connection': this._connection
                }));
                if (this._connection !== navigator.onLine) { // Update connect if change
                    this.updateConnection(navigator.onLine);
                }
            });


            // Update _connection$ when change connection
            this.onNetworkChange((isOnline) => {
                // Show notification only when there is a change otherwise its stupid
                if (isOnline !== this._connection) {
                    this.updateConnection(isOnline);
                }
            });
        },


        /**
         *
         * @param callback{Function}
         */
        onNetworkChange(callback) {
            // Online
            let timerOnline;
            document.addEventListener('online', () => {
                if (timerOnline) { // Stop watch online
                    this.$timeout.cancel(timerOnline);
                    timerOnline = null;
                }

                if (navigator.onLine) {
                    callback(true);
                } else {
                    // Watch online
                    timerOnline = this.$timeout(() => {
                        if (navigator.onLine) {
                            if (timerOnline) { // Stop watch online
                                this.$timeout.cancel(timerOnline);
                                timerOnline = null;
                            }
                            callback(true);
                        }
                    }, 2000);
                }

            }, false)


            // offline
            document.addEventListener('offline', () => {
                if (timerOnline) { // Stop watch online
                    this.$timeout.cancel(timerOnline);
                    timerOnline = null;
                }
                callback(false);
            }, false);
        }
    }
    NetworkInfoService.$inject = ['$q', 'DeviceService', '$timeout'];
    return NetworkInfoService;
}());
angular.module('shared').service('NetworkInfoService', NetworkInfoService);